const i = (e) => e === void 0;
export {
  i
};
